import Drawer from "components/Drawer/index";
import Modal from "components/Models/index";
import { useToast } from "components/Toaster/index";
import UpdatePassword from "components/UpdatePassword/index";
import useScreenMobile from "hooks/useScreen";
import React, { useState } from "react";
import { ManageUser as MU } from "@induz/sdk";

const SecurityUpdatePassword = ({
  handlecancel,
  setVerifyPassword,
  currentPassword,
  setCurrentPassword
}) => {
  const isMobile = useScreenMobile({ size: 992 });
  const showToast = useToast();
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  const [isPasswordVisible, setIsPasswordVisible] = useState(false);
  const [isConfirmPasswordVisible, setIsConfirmPasswordVisible] =
    useState(false);
  const [currentPasswordError, setCurrentPasswordError] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const handleSave = async () => {
    if (isLoading) return;

    try {
      if (password === confirmPassword) {
        setIsLoading(true);
        await MU.changePasswordWithOldPassword(currentPassword.password, password);
        setIsLoading(false);
        setVerifyPassword(false);
        showToast("Password updated successfully", "success");
        setCurrentPassword({ password: "", pin: "" });
        setPassword("");
        setConfirmPassword("");
        setCurrentPasswordError("");
      } else {
        showToast("Passwords do not match", "error");
        return;
      }
    } catch (error) {
      setIsLoading(false);
      console.error("error during change password", error);
      if (error?.message?.toLowerCase().includes("invalid old password") ||
        error?.message?.toLowerCase().includes("incorrect password") ||
        error?.message?.toLowerCase().includes("wrong password") ||
        error?.toString().toLowerCase().includes("invalid old password") ||
        error?.toString().toLowerCase().includes("incorrect password")) {
        setCurrentPasswordError("Incorrect current password");
        showToast("Current password is incorrect.", "error");
      } else {
        showToast(error?.message || "Error during change password", "error");
      }
    }

  };

  return isMobile ? (
    <Drawer
      isVisible={true}
      heading="Update Password"
      handleCancel={handlecancel}
      showFooter={false}
    >
      <UpdatePasswordContent
        password={password}
        setPassword={setPassword}
        confirmPassword={confirmPassword}
        setConfirmPassword={setConfirmPassword}
        isPasswordVisible={isPasswordVisible}
        setIsPasswordVisible={setIsPasswordVisible}
        isConfirmPasswordVisible={isConfirmPasswordVisible}
        setIsConfirmPasswordVisible={setIsConfirmPasswordVisible}
        handleSave={handleSave}
        currentPassword={currentPassword}
        setCurrentPassword={setCurrentPassword}
        showCurrentPassword={true}
        currentPasswordError={currentPasswordError}
        setCurrentPasswordError={setCurrentPasswordError}
        isLoading={isLoading}
      />
    </Drawer>
  ) : (
    <Modal
      showFooter={false}
      heading="Update Password"
      handleCancel={handlecancel}
    >
      <UpdatePasswordContent
        password={password}
        setPassword={setPassword}
        confirmPassword={confirmPassword}
        setConfirmPassword={setConfirmPassword}
        isPasswordVisible={isPasswordVisible}
        setIsPasswordVisible={setIsPasswordVisible}
        isConfirmPasswordVisible={isConfirmPasswordVisible}
        setIsConfirmPasswordVisible={setIsConfirmPasswordVisible}
        handleSave={handleSave}
        currentPassword={currentPassword}
        setCurrentPassword={setCurrentPassword}
        showCurrentPassword={true}
        currentPasswordError={currentPasswordError}
        setCurrentPasswordError={setCurrentPasswordError}
        isLoading={isLoading}
      />
    </Modal>
  );
};

export default SecurityUpdatePassword;

const UpdatePasswordContent = (props) => {


  return <UpdatePassword {...props} />;
};
